import { SVGProps } from "react";

export default function DoctorIcon({
  width = "24",
  height = "24",
  className = "",
  stroke = "#000080",
}: SVGProps<SVGSVGElement> & { stroke?: string }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.1014 12.4062L14.5002 14.0013"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 7H8"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 3H14C15.1046 3 16 3.89543 16 5V9C16 11.2091 14.2091 13 12 13V13C9.79086 13 8 11.2091 8 9V5C8 3.89543 8.89543 3 10 3Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.9008 12.4062L9.1578 15.3783"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 16.0627C11.5898 16.3426 10.1263 16.0454 8.937 15.2375C8.73736 15.1047 8.49315 15.0565 8.258 15.1035L5.412 15.6725C4.0095 15.9529 2.99991 17.1843 3 18.6145V18.9985"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 15.1562V18.9997"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="8"
        cy="20.5"
        r="1.5"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8302 16.5173L17.9999 16.6896L18.1754 16.5042C18.473 16.1866 18.8876 16.0045 19.3229 16.0001C19.7582 15.9957 20.1763 16.1695 20.4804 16.481L20.516 16.5172C21.1613 17.1803 21.1613 18.2366 20.516 18.8997L18.7617 20.681C18.5608 20.8851 18.2864 21 18 21C17.7135 21 17.4391 20.8851 17.2382 20.681L15.4839 18.8997C14.8387 18.2366 14.8387 17.1803 15.4839 16.5173V16.5173C15.7934 16.2029 16.216 16.0259 16.6571 16.0259C17.0982 16.0259 17.5208 16.2029 17.8302 16.5173Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
